import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import ReactJson from 'react-json-view'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.product')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.long_name')} value={record.long_name} />
          <ShowListElement label={translate('ra.field.short_name')} value={record.short_name} />
          <ShowListElement
            label={translate('ra.field.product-type')}
            value={record.product_type_relation?.long_name}
          />
          <ShowListElement
            label={translate('ra.field.offline_product')}
            value={record.is_offline}
            type='boolean'
          />
          <ShowListElement label={translate('ra.field.ref_table_detail')} value={record.ref_table_detail} />
          <div style={{display:'flex', flexDirection:'column', margin:'10px'}}>
            <label htmlFor="jsonMap" style={{fontWeight:'bold'}}>{translate('ra.field.mapping')}</label>
            <ReactJson
                id='jsonMap'
                src={record.api_map}
                collapsed={1} 
                enableClipboard={(copy) => {
                  try {
                    navigator.clipboard.writeText(JSON.stringify(copy.src));
                  } catch (e) {
                  }
                }}
                displayDataTypes={false}
              />
          </div>
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const ProductShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
